<form class="modal-body" [formGroup]="form" novalidate>
  <div class="centermodal__form">
    <input type="hidden" ngbAutofocus />
    <p class="centermodal__title">{{ 'settings.partnerships' | translate }}</p>
    <p class="centermodal__description">{{ 'settings.partnersPlanDescription' | translate }}</p>
    <div class="partners-content">
      <app-select placeholder="{{ 'settings.partner' | translate }}" [disableSearch]="true" formControlName="isp_code" [options]="ispOptions"> </app-select>
      <label class="field__holder full" [appFormControlWrap]="form.get('login')">
        <input type="text" class="field" formControlName="login" name="login" autocomplete="none" required data-sentry-mask autocorrect="off" spellcheck="false" autocapitalize="off" />
        <span class="field__placeholder">{{ 'settings.login' | translate }}</span>
      </label>
      <label class="field__holder full" [appFormControlWrap]="form.get('password')">
        <input
          type="password"
          class="field"
          formControlName="password"
          name="password"
          autocomplete="none"
          required
          appShowPassword
          data-sentry-mask
          autocorrect="off"
          spellcheck="false"
          autocapitalize="off"
        />
        <span class="field__placeholder">{{ 'settings.password' | translate }}</span>
      </label>
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled btn-filled-cancel" (click)="close()">
      {{ 'button.back' | translate }}
    </button>
    <button type="button" class="btn-L btn-filled" (click)="confirm()" [disabled]="isActivating || form.invalid">
      @if (!isActivating) {
        <span>{{ 'button.activate' | translate }}</span>
      } @else {
        <i class="fal fa-spinner-third fa-spin"></i>
      }
    </button>
  </div>
</form>
